import React,{useEffect, useState} from 'react';
import {Form,Row,Col,Input,Button,Space,Select, Table,Tooltip} from 'antd';
import {useHistory} from 'react-router-dom';
import {getQualityGradientSelect,updateQualityGradientStatus} from '../util/api';
import { message } from 'antd';
// import CpEmpty from '../../../components/CpEmpty';
const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};
const {Option} = Select;

const renderGradient = (data = []) => {
  if (Array.isArray(data)) {
    return (
      <div style={{display: 'flex', justifyContent: 'space-between'}}>
        <div key={0}>
          <Space >
            <span>{`${data[0].lower} < X ≤ ${data[0].high} / ${data[0].rate}%`}</span>
          </Space>
        </div>
        {
          data.length > 1 ? <Tooltip title={<>
            {
              data.map((item, i) => {
                return (
                  <div key={i}>
                  <Space >
                    <span>{`${item.lower} < X ≤ ${item.high} / ${item.rate}%`}</span>
                  </Space>
                  </div>
                );
              })
            }
            </>}>
            <span style={{cursor:'pointer'}}>详情</span>
          </Tooltip> : ""
        }

      </div>
    );
  }
};

const QualityGradient = ()=>{
  const  history = useHistory();
  const [form] = Form.useForm();
  const [page,setPage] = useState({
    page:1,
    page_size:10
  });
  const [total,setTotal] = useState(0);
  const [list,setList] = useState([]);
  const columns = [
    {
      title:'梯度规则名称',
      dataIndex:'name',
      align:'center',
      ellipsis: {
        showTitle: false,
      },
      render: (text) => (
        <Tooltip placement="topLeft" title={text}>
          {text}
        </Tooltip>
      ),
    },
    {
      title:'异常占比',
      dataIndex:'abnormal_prop',
      align:'center',
      render:val=> (val+ '%') ?? ''
    },
    {
      title:'到货数量(X)/抽检比例',
      dataIndex:'gradient',
      align:'center',
      render:data=>renderGradient(data)
    },
    {
      title:'状态',
      dataIndex:'status',
      align:'center',
      render:val => val === 1 ?'启用':'禁用'
    },
    {
      title:'操作',
      dataIndex:'op',
      align:'center',
      render:(_,record)=>{
        return (
          <>
            <Space>
              <span style={{cursor:'pointer'}} onClick={()=>history.push('/basic/user/qualityGradient/detail/'+record.id)}>查看</span>
              <span style={{cursor:'pointer'}} onClick={()=>handleQualityGradientStatus(record)}>{record.status === 1 ?'禁用':'启用'}</span>
            </Space>
          </>
        );
      }
    },
  ];
 const handleQualityGradientStatus= async (record) => {
  const result = await updateQualityGradientStatus({
    id:record.id,
    status:record.status === 1 ? 2:'1'
  });
  const {code,msg} = result.data || {};
   if(code === 0){
      message.success(msg);
      setPage({
        page:1,
        page_size:10
      });
   }else{
    message.error(msg);
   }
  };
  const getList = async () => {
    const values = form.getFieldsValue();
    const result = await getQualityGradientSelect({
      ...values,
      ...page,
    });
   const {code,data:{list=[],total}={}} = result.data || {};
   if(code === 0){
      setList(list);
      setTotal(total);
   }
 };
 const tablePageChange = (page, page_size) => {
  setPage({page,page_size });
};
const handleQuery = () => {
  setPage({page:1,page_size:10 });
};

const reset = () => {
  form.resetFields();
  setPage({page:1,page_size:10 });
};
  useEffect(()=>{
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[page]);
  // const empty = (
  //   <div className="address-empty">
  //     <CpEmpty status={'qualityGradient'} />
  //   </div>
  // );
  return (
    <>
     <h2>抽检梯度</h2>
     <div>
      <Form {...layout} onFinish={handleQuery} form={form}>
        <Row span={24}>
          <Col span={8}>
          <Form.Item
            label="梯度规则名称"
            name="name"
          >
            <Input />
          </Form.Item>
          </Col>
          <Col span={8}>
          <Form.Item
            label="状态"
            name="status"
            initialValue=''
          >
           <Select>
            <Option value={''} >全部</Option>
            <Option value={1} >启用</Option>
            <Option value={2} >禁用</Option>
           </Select>
          </Form.Item>
          </Col>
          <Col span={8}>
          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Space>
            <Button type="primary" htmlType="submit">
              查询
            </Button>
            <Button onClick={reset} >
             重置
            </Button>
            </Space>
          </Form.Item>
          </Col>
        </Row>
        </Form>
        <div>
        <Space direction="vertical" style={{ display: 'flex' }}>
          <Button type='primary' onClick={()=>history.push('/basic/user/qualityGradient/detail')}>创建抽检梯度</Button>
           <Table 
            columns={columns}
            dataSource={list}
            className='quality-table-cell'
            rowKey={'id'}
            pagination={{
              pageSize: page.page_size,
              total: total,
              current: page.page,
              onChange: tablePageChange
            }}
          />
          </Space>
        </div>
     </div>
    </>
  );
};

export default QualityGradient;